import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import { AnimatePresence } from 'framer-motion';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import CategorySection from '../components/CategorySection';
import Footer from '../components/Footer';
import ProductCategories from '../components/ProductCategories'; 
import PageLoader from '../components/PageLoader';
import SEO from '../components/SEO';
import ValentinesBanner from '../components/ValentinesBanner';
import { getFeaturedProducts } from '../api/products';
import useDeviceType from '../hooks/useDeviceType';

const Home = () => {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showLoader, setShowLoader] = useState(true);
  const [heroReady, setHeroReady] = useState(false);
  
  const deviceType = useDeviceType();

  useEffect(() => {
    const fetchFeaturedProducts = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await getFeaturedProducts(deviceType);
        setFeaturedProducts(data);
      } catch (error) {
        console.error('Error fetching featured products:', error);
        setError('Failed to fetch featured products. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedProducts();
  }, [deviceType]);

  // Handle loader completion
  const handleLoadComplete = () => {
    setShowLoader(false);
    // Signal hero to start animation
    setTimeout(() => {
      setHeroReady(true);
    }, 100);
  };

  return (
    <>
      {/* SEO Meta Tags */}
      <SEO 
        title="Home"
        description="Discover AGNIR's exquisite collection of handcrafted jewelry. Shop premium rings, bracelets, chains, and pendants with fire-inspired aesthetics. Experience luxury fashion accessories with timeless elegance and modern design."
        keywords="jewelry, premium jewelry, handcrafted jewelry, rings, bracelets, chains, pendants, fashion jewelry, luxury accessories, fire aesthetics, elegant jewelry, statement pieces, designer jewelry, online jewelry store"
        url="https://agnir.co/"
        image="https://agnir.co/hero-bg.webp"
      />
      
  {/* Full Page Loader - appears on every visit */}
      <AnimatePresence mode="wait">
        {showLoader && (
          <PageLoader key="loader" onLoadComplete={handleLoadComplete} />
        )}
      </AnimatePresence>

      {/* Main Content */}
      <Box opacity={showLoader ? 0 : 1} transition="opacity 0.5s ease-in-out">
        {/* <Navbar /> */}
        <Hero startAnimation={heroReady} />
        <Box bgImage={`url(${process.env.REACT_APP_BG_URL})`}>
          <ProductCategories />
          
          {/* Valentine's Banner - Between collections and featured */}
          <Box px={{ base: 4, md: 8, lg: 16 }}>
            <ValentinesBanner variant="inline" />
          </Box>
          
          <CategorySection products={featuredProducts} loading={loading} error={error} />
        </Box>
        {/* <Footer /> */}
      </Box>
    </>
  );
};

export default Home;